// pages/Stands.js
import React, { useEffect } from 'react';
import Carousel from '../components/Carousel';

function StandsAMZ() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="stands-page">

    <div style={{
      padding: '80px 0 40px',
      textAlign: 'center',
      backgroundImage: 'url(/images/cover.jpg)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      position: 'relative',
      width: '100%',
      marginLeft: 'calc(-50vw + 50%)',
      minHeight: '400px'
    }}>
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        zIndex: 1
      }}></div>
      <div className="container" style={{ position: 'relative', zIndex: 2, padding: '0 20px' }}>

      <style jsx>{`
        @media (max-width: 768px) {
          .stands-page > div:first-child {
            padding: 60px 0 30px !important;
            min-height: 300px !important;
          }
          .stands-page h1 {
            font-size: 2.5rem !important;
          }
          .stands-page h3 {
            font-size: 1.4rem !important;
          }
        }
      `}</style>
      <img
        src="/images/Asset7.png"
        alt="Stands Icon"
        style={{
          width: '80px',
          height: '80px',
          objectFit: 'contain'
        }}
      />
      <h1 style={{
        fontSize: '3.5rem',
        marginBottom: '20px',
        background: 'linear-gradient(135deg, var(--primary-orange), var(--secondary-orange))',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
        textAlign: 'center'
      }}>
      ⵉⴼⵙⴰⵔⵏ ⴷ ⵉⴳⵎⵎⴰⴹⵏ ⵉⵎⵢⴰⵖⵏ
      </h1>

      <h3 style={{
        fontSize: '2rem',
        marginBottom: '20px',
        fontWeight: '600',
        lineHeight: '1.6',
        textAlign: 'center'
      }}>
        "ⴰⴷ ⵓⵔ ⵏⴼⵉⵙⵙ ⵅⴼ ⵜⴽⵕⴹⵉ"

      </h3>
      </div>
    </div>

      {/* Context Section */}
      <div style={{ background: 'var(--secondary-black)', padding: '60px 0' }}>
        <div className="container">

          {/* Context Description */}
          <div style={{ marginBottom: '50px' }}>
            <h3 style={{
              fontSize: '2.3rem',
              marginBottom: '35px',
              textAlign: 'center',
              color: 'var(--white)'
            }}>
              ⴰⵎⵏⴰⴹ
            </h3>

            <div style={{
              background: 'linear-gradient(135deg, rgba(255, 107, 53, 0.1), rgba(255, 133, 85, 0.05))',
              padding: '35px',
              borderRadius: '15px',
              borderRight: '5px solid var(--primary-orange)',
              marginBottom: '40px'
            }}>
            <p style={{
        fontSize: '1.15rem',
        lineHeight: '2',
        color: 'var(--text-light)',
        justifySelf: 'center',
        marginBottom: '20px',
        textAlign: 'center'
      }}>
        ⴳ ⵓⵎⵏⴰⴹ ⵏ ⵓⵎⵣⵉⵣⵣⵍ ⴰⵏⴰⵎⵓⵔ ⵏ ⵓⵙⴱⴷⴷⵉ ⵏ ⵜⴽⵕⴹⵉ ⵎⴳⴰⵍ ⵜⵉⵡⵜⵎⵉⵏ ⴷ ⵜⵔⴱⴰⵜⵉⵏ, ⵜⵜⵙⵡⴰⴷⴷⵓ ⴰⵙⴳⴳⵯⴰⵙ ⴰⴷ ⵙ ⵓⵙⵏⵜⵍ{' '}
        <strong style={{ color: 'var(--primary-orange)' }}>
          "ⵜⴰⴽⵕⴹⵉ ⵉⵜⵜⵓⵙⴰⵀⴰⵍⵏ ⵙ ⵜⵉⴽⵏⵓⵍⵓⵊⵉⵜ ⵎⴳⴰⵍ ⵜⵉⵡⵜⵎⵉⵏ ⴷ ⵜⵔⴱⴰⵜⵉⵏ: ⵜⴰⵔⵡⵍⴰ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ ⵜⴰⴼⵙⵙⴰⵢⵜ ⵜⵙⵖⵉⴹⴹ ⴰⵎⵓⵏ"
        </strong>{' '}
        , ⵉⵣⴷⵉⵏ ⵙⴳ 25 ⵏⵓⵡⴰⵏⴱⵉⵔ ⴰⵔ 10 ⴷⵓⵊⴰⵏⴱⵉⵔ 2025, ⵉⵙⵙⵓⴷⴷⵙ ⵓⵙⵇⵇⵉⵎ ⴰⵏⴰⵎⵓⵔ ⵏ ⵉⵣⵔⴼⴰⵏ ⵏ ⵓⴼⴳⴰⵏ ⵉⴼⵙⴰⵔⵏ ⴷ ⵉⴳⵎⵎⴰⴹⵏ ⵉⵎⵢⴰⵖⵏ ⴳ ⴽⵕⴰⴹⵜ ⵏ ⵉⵙⴰⵢⵔⴰⵔⵏ ⵉⴳⴷⵓⴷⴰⵏ ⵉⵎⵇⵇⵕⴰⵏⵏ ⴳ ⵜⵎⴷⵉⵏⵜ ⵏ ⵕⵕⴱⴰⵟ.
      </p>


      <p style={{
        fontSize: '1.2rem',
        lineHeight: '2',
        color: 'var(--text-light)',
        textAlign: 'center'
      }}>
        ⵜⵜⴰⴽⴽⴰⵏⵜ ⵉⵣⴰⵔⵓⵜⵏ ⴰⴷ ⵉⵕⵥⵎⵏ ⵉ ⵉⵏⵎⵖⵓⵔⵏ ⵜⵉⵔⵎⵉⵜ ⵉⵙⵎⵓⵏⵏ ⵉⵏⴳⵔ ⵓⴼⵔⴰⴽ ⴷ ⵓⵙⴼⵔⴽ ⴷ ⵓⵎⵢⴰⵖ ⴷ ⵓⵙⵍⵍⵉ, ⵙ ⵜⴰⵍⵖⴰ ⵉⵙⵙⵏⵎⴰⵍⴰⵏ ⵜⴰⴼⴰⵜ ⵅⴼ ⵢⴰⵜ ⵙⴳ ⵜⵡⵓⵔⵉⵡⵉⵏ ⵜⵉⵣⵔⴼⴰⵏⵉⵏ ⵜⵉⵎⵇⵇⵕⴰⵏⵉⵏ, ⴳ ⵜⴰⵍⵖⴰ ⵏⵏⵙ ⵜⴰⵍⵉⴽⵜⵕⵓⵏⵉⵜ ⴷ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ.
      </p>

            </div>
          </div>

          {/* Objectives Section */}
          <div style={{ marginBottom: '50px', direction:'ltr' }}>
            <h3 style={{
              fontSize: '2.3rem',
              marginBottom: '35px',
              textAlign: 'center',
              color: 'var(--white)'
            }}>
              ⵜⵙⵡⵓⵜⵜⵙ ⵜⵙⵏⵜⴰⵢⵜ ⴰⴷ
            </h3>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: '25px',
              textAlign:'left'
            }}>
              {[

                {
                  icon: '🔒',
                  title: 'ⴰⵙⴼⵔⴽ ⴷ ⵓⵎⵢⴰⵖ',
                  desc: 'ⴰⵎⵢⴰⵖ ⴰⴽⴷ ⵜⵏⵎⵓⵔⵉⵢⵉⵏ ⴷ ⵉⵏⵎⵓⵔⴰⵏ ⴷ ⵓⵙⴼⵔⴽ ⵙ ⵜⵎⵉⵣⵉⵜ ⵏ ⵜⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ ⵎⴳⴰⵍ ⵜⵉⵡⵜⵎⵉⵏ ⴷ ⵜⵔⴱⴰⵜⵉⵏ',
                },
                {
                  icon: '📚',
                  title: 'ⴰⵙⵏⵎⵍ ⵏ ⵜⵡⵉⵍⴰⵜⵉⵏ ⵏ ⵜⴽⵕⴹⵉ',
                  desc: 'ⴰⵙⵏⵎⵍ ⵙ ⵜⵡⵉⵍⴰⵜⵉⵏ ⵏ ⵜⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ ⴷ ⵉⴷⵔⵉⵣⵏ ⵏⵏⵙ'
                },
                {
                  icon: '🔔',
                  title: 'ⴰⵙⵔⵇⴱ ⵏ ⵓⵙⵙⵉⵡⴹ',
                  desc: 'ⴰⵙⵔⵇⴱ ⵏ ⵜⵡⵜⵎⵉⵏ ⴷ ⵜⵔⴱⴰⵜⵉⵏ ⵅⴼ ⵓⵙⵙⵉⵡⴹ ⵅⴼ ⵜⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ ⴷ ⵜⵕⵥⵉ ⵏ ⵓⴳⴰⴷⵉⵔ ⵏ ⵉⴼⵙⵙⵜⵉ'
                }
              ].map((item, index) => (
                <div key={index} style={{
                  background: 'var(--primary-black)',
                  padding: '25px',
                  borderRadius: '15px',
                  border: '1px solid rgba(255, 107, 53, 0.3)',
                  transition: 'all 0.3s ease',

                  textAlign:'left'
                }}>
                  <div style={{ fontSize: '2.5rem', marginBottom: '15px' }}>{item.icon}</div>
                  <h4 style={{ fontSize: '1.4rem', marginBottom: '12px', color: 'var(--primary-orange)' }}>
                    {item.title}
                  </h4>
                  <p style={{ fontSize: '1.05rem', lineHeight: '1.7', color: 'var(--text-light)' }}>
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Locations and Dates */}
          <div style={{ marginBottom: '50px', direction:'ltr', textAlign:'left' }}>
            <h3 style={{
              fontSize: '2.3rem',
              marginBottom: '35px',
              textAlign: 'center',
              color: 'var(--white)',

            }}>
              ⵏⵙⵙⵓⵜⵔ ⴳⵉⵜⵓⵏⵜ(ⵜⵓⵏ) ⴰⴷ ⵜⵔⵣⴼⵎⵜ(ⵎ) ⵉⴳⵎⵎⴰⴹⵏ ⵏ ⵓⵎⵣⵉⵣⵣⵍ ⴳ ⵉⵙⴰⴽⵓⴷⵏ ⵉⵏⴹⴼⴰⵕⵏ
            </h3>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '25px' }}>
              {[
                {
                  dates: '25–29 ⵏⵓⵡⴰⵏⴱⵉⵔ 2025',
                  location: 'ⵎⴰⵃⴰⵊⵊ ⵕⵕⵉⵢⴰⴹ, ⵕⵕⴱⴰⵟ',
                  icon: '📍'
                },
                {
                  dates: '30 ⵏⵓⵡⴰⵏⴱⵉⵔ - 4 ⴷⵓⵊⴰⵏⴱⵉⵔ 2025',
                  location: 'ⵎⵏⵉⴷ ⵏ ⵓⴱⵕⵍⴰⵎⴰⵏ',
                  icon: '🏛️'
                },
                {
                  dates: '5 – 9 ⴷⵓⵊⴰⵏⴱⵉⵔ 2025',
                  location: 'ⴰⵙⵔⵙ ⵏ ⵓⵍⴰⵡⴰⵢ ⵕⵕⴱⴰⵟ ⴰⴳⴷⴰⵍ',
                  icon: '🚉'
                }
              ].map((item, index) => (
                <div key={index} style={{
                  background: 'var(--primary-black)',
                  padding: '30px',
                  borderRadius: '15px',
                  border: '2px solid var(--primary-orange)',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '25px',
                  transition: 'all 0.3s ease',

                }}>
                  <div style={{
                    fontSize: '3rem',
                    minWidth: '60px',
                    textAlign: 'center'
                  }}>
                    {item.icon}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{
                      background: 'linear-gradient(135deg, var(--primary-orange), var(--secondary-orange))',
                      padding: '10px 20px',
                      borderRadius: '10px',
                      fontWeight: '700',
                      fontSize: '1.2rem',
                      marginBottom: '15px',
                      display: 'inline-block',

                    }}>
                      {item.dates}
                    </div>
                    <h4 style={{
                      fontSize: '1.5rem',
                      color: 'var(--white)',
                      lineHeight: '1.6'
                    }}>
                      {item.location}
                    </h4>
                  </div>
                </div>
              ))}
            </div>
          </div>

    <div className="section-separator"></div>

          <div style={{ textAlign: 'center', marginTop: '50px' }}>
            <h3 style={{
              fontSize: '2.5rem',
              marginBottom: '25px',
              color: 'var(--white)',
              textAlign: 'center'
            }}>
            ⴷⵔⵓⵢⴰⵜ ⴷⵉⴷⵏⵖ ⴳ ⵓⵎⵣⵉⵣⵣⵍ ⴰⵏⴰⵎⵓⵔ ⵏ ⵓⵙⴱⴷⴷⵉ ⵏ ⵜⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ ⵎⴳⴰⵍ ⵜⵉⵡⵜⵎⵉⵏ ⴷ ⵜⵔⴱⴰⵜⵉⵏ
            </h3>

            <p style={{
              fontSize: '1.2rem',
              marginTop: '30px',
              color: 'var(--text-light)',
              fontStyle: 'italic',
              textAlign: 'center'
            }}>
          ⴰⴷ ⵓⵔ ⵏⴼⵉⵙⵙ ⵅⴼ ⵜⴽⵕⴹⵉ
            </p>
          </div>
        </div>
      </div>

  <Carousel />
    </div>
  );
}

export default StandsAMZ;
